<template>
    <article class="tile is-child card">
        <header class="card-header">
            <p class="title">Updates</p>

            <a
                @click="newUpdate()"
                class="card-header-icon"
            >Add</a>
        </header>
        <div class="content">
            <p class="panel-tabs">
                <a
                    :class="{'is-active': isFiltering('all')}"
                    @click="filterAs('all')"
                >All</a>

                <a
                    :class="{'is-active': isFiltering('last_two_weeks')}"
                    @click="filterAs('last_two_weeks')"
                >Last two weeks</a>
            </p>
            <div v-if="loading" class="centered loader is-medium"></div>
            <div v-else-if="isNotEmpty" class="content-holder scrollbox pt0">
                <span
                    class="panel-block"
                    v-for="update in filteredUpdates"
                    :key="update.id"
                >
                    <a
                        :href="route('projects.show', {project: update.project_id})"
                    >
                        <span class="tag is-light mrs" v-text="getUpdateTypeLabel(update)"></span>
                        <span>{{ update.title }}</span>
                    </a>
                    <span class="is-pulled-right">
                        <span>
                            <i>
                                at {{ moment(update.created_at).format('LLLL') }}
                            </i>
                        </span>
                        <a
                            class="mls button is-success is-small"
                            @click="openDetailsModal(update)"
                        >
                            <span>View</span>
                        </a>
                    </span>
                </span>
            </div>
            <div class="notification" v-else>
                <p>{{ trans('app.project.update.none') }}</p>
            </div>
        </div>

        <project-update-add-general-modal
            :account-id="accountId"
        ></project-update-add-general-modal>
    </article>
</template>

<script>

export default {
    props: {
        accountId: {
            type: Number,
            required: true,
        },
    },

    data () {
        return {
            loading: true,
            activeFilter: 'last_two_weeks',
            updates: [],
        };
    },

    computed: {
        isNotEmpty () {
            return ! _.isEmpty(this.updates);
        },

        filteredUpdates () {
            if (this.activeFilter === 'last_two_weeks') {
                return _.filter(this.updates, update => {
                    let twoWeeksAgo = moment().startOf('day')
                        .subtract(2, 'week');
                    let currentUpdateDay = this.moment(update.created_at).startOf('day');

                    return currentUpdateDay >= twoWeeksAgo;
                });
            }

            if (this.activeFilter === 'all') {
                return this.updates;
            }

            return [];
        },
    },

    listeners: {
        async 'project-updates-updated' () {
            await this.fetchList();
        },
    },

    methods: {
        filterAs (filter) {
            this.activeFilter = filter;
        },

        isFiltering (filter) {
            return this.activeFilter === filter;
        },

        getUpdateTypeLabel (update) {
            if (update.related_type === 'project') {
                return 'Project';
            }
        },

        openDetailsModal (update) {
            OSPEvent.$emit('open-project-update-details', update);
        },

        newUpdate () {
            OSPEvent.$emit('open-project-update-general-add-modal');
        },

        async fetchList () {
            try {
                this.loading = true;
                let {data} = await axios.get(rotue('project_updates.index', {account_id: this.accountId}));

                this.updates = data.data;

                OSPEvent.$emit('project-updates-fetched', {total: this.updates.length});
            } catch (errors) {
                console.error(errors);
            } finally {
                this.loading = false;
            }
        },
    },

    async created () {
        await this.fetchList();
    },
};
</script>
